import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { MLRSSUtil } from 'ml-portals-util-js';

import styles from './MLProducerNewsComponent.module.scss';
import messages from './MLProducerNewsComponent.messages';
import metadata from './MLProducerNewsComponent.metadata.json5';

const MLProducerNewsComponent = (props) => {
    const {
        userType,
        rowLimit
    } = props;

    const translator = useTranslator();
    const [isLoading, updateIsLoading] = useState(true);
    const [producerNews, updateProducerNews] = useState([]);
    const feedLink = `https://foremostproducernews.com/feed`;

    const loadProducerNewsData = () => {
        if (userType !== '') {
            MLRSSUtil.retrieveRSSDataFromFeed(feedLink).then((res) => {
                try {
                    const payload = MLRSSUtil.handleOnLoad(res);
                    const filteredPayload = payload.filter((item) => _.isString(item.channel) ? item.channel === userType : item.channel.indexOf(userType) > -1) || [];
                    const filterProducerNews = _.orderBy(filteredPayload, ['pubDate'], ['desc']).slice(0, rowLimit);
                    updateProducerNews(filterProducerNews);
                    updateIsLoading(false);
                } catch(error) {
                    console.error(error);
                    updateIsLoading(false); 
                }               
            }, (error) => {
                console.error(error);
                updateIsLoading(false);
            });
        }
    };

    useEffect(() => {
        loadProducerNewsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userType]);

    const getFilteredDate = useCallback((aDate) => {
        const today = moment();
        const yesterday = moment().subtract(1, 'days');
        const tomorrow = moment().add(1, 'days');
        const date = moment(aDate);
        if (!aDate)  return '—'; 
        if (date.isSame(yesterday, 'd'))  return translator(messages.yesterday);
        if (date.isSame(today, 'd')) return translator(messages.today);
        if (date.isSame(tomorrow, 'd'))  return translator(messages.tomorrow);
        return moment(aDate).format('MM/DD/YYYY');
    }, [translator]);

    const renderPubDateCell = useCallback((item) => {
        return  (
            <span>
                {getFilteredDate(item.pubDate)}
            </span>
        )
    }, [getFilteredDate]);

    const openProducerNewsLink = useCallback((event, item) => {
        event.preventDefault();
        window.open(item.link, '_blank');
    }, []);

    const renderTitleCell = useCallback((item) => {
        return (
            <Link aria-label='opens in a new window' href="/" mlTagManagerLinkClick={`Dashboard_article_${item.title}`} onClick={(event) => openProducerNewsLink(event, item)}>
                {item.title}
            </Link>
        );
    }, [openProducerNewsLink]);

    const overrideProps = {
        statusDesc: {
            visible: isLoading,
            content: translator(messages.loading)
        },
        producerNewsTable: {
            data: producerNews,
            visible: !isLoading,
            titleId: 'producerNewsHeader'
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            renderPubDateCell,
            renderTitleCell
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

MLProducerNewsComponent.propTypes = {
    userType: PropTypes.string.isRequired,
    rowLimit: PropTypes.number.isRequired
}

MLProducerNewsComponent.defaultProps = {
    userType: ''
}

export default withViewModelService(MLProducerNewsComponent);
